import React from 'react';
// import "./react-dom-shim";
import ReactDOM from 'react-dom/client';
import './style.css';
import './index.css';
import "slick-carousel/slick/slick.css"; 
import "slick-carousel/slick/slick-theme.css";
import App from './App.js';
import reportWebVitals from './reportWebVitals.js';
import 'semantic-ui-css/semantic.min.css'
import { BrowserRouter } from "react-router";
import { AuthProvider } from './context/AuthContext.js';
import { NavigationTabContextProvider } from './context/NavigationTabContext.js';
import { ToastContainer } from 'react-toastify';

// if (!ReactDOM.findDOMNode) {
//   ReactDOM.findDOMNode = () => {
//     // throw new Error("findDOMNode is no longer supported in React 19.");
//   };
// }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
  <AuthProvider>
    <BrowserRouter>
    <NavigationTabContextProvider>
      <App />
      <ToastContainer />
      </NavigationTabContextProvider>
    </BrowserRouter>
  </AuthProvider>
  // {/* </React.StrictMode> */}
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
